import BasePage from "../../../../base/BasePage";
// import {NavBar} from "nq-component";
import React from "react";
import PersonalInfoPresenter from "./PersonalInfoPresenter";
import { addSchemaUseCase } from "../../../../usecases/schema/usecases";
import CardView from "../../../../components/common/CardView";
import { formatDate } from "../../../../components/common/Converter";

class PersonalInfoPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new PersonalInfoPresenter(this, addSchemaUseCase());
    this.state = { progress: false };
  }

  showProgress() {
    this.setState({ progress: true });
  }

  hideProgress() {
    this.setState({ progress: false });
  }

  render() {
    const {
      birthDate,
      birthPlace,
      sex,
      civil,
      citizenship,
      height,
      weight,
      blood,
      tin,
      gsis,
      sss,
      philhealth,
      pagIbig,
      residentialAdd,
      permanentAdd,
      educationalBackground,
      workExperienceBackground,
    } = this.props;

    const tableData = (thead, tbody) => {
      return (
        <tr className="row">
          <th className="col-lg-4 pb-2">{thead}</th>
          <td className="col-lg-8 pb-2">{tbody}</td>
        </tr>
      );
    };
    return (
      <>
        <div className="row m-auto w-100 mb-2">
          <div
            className="col-lg-6 mb-2 d-flex h-100"
            style={{ padding: "0  5px 0 5px" }}
          >
            <CardView
              style={{
                padding: 0,
                borderRadius: 0,
              }}
            >
              <div
                style={{
                  color: "#333",
                  borderBottom: "1px solid #ccc",
                  display: "flex",
                  paddingLeft: "1.5rem",
                  paddingTop: "1rem",
                  paddingBottom: "1rem",
                  alignItems: "center",
                }}
              >
                <p style={{ margin: 0 }}>Personal Information</p>
              </div>
              <div
                style={{
                  paddingLeft: "1.5rem",
                  paddingTop: "1rem",
                  fontSize: "13px",
                }}
              >
                <table>
                  {tableData("Birthdate: ", birthDate)}
                  {tableData("Birth Place: ", birthPlace)}
                  {tableData("Gender: ", sex)}
                  {tableData("Civil Status: ", civil)}
                  {tableData("Citizenship: ", citizenship)}
                  {tableData("Height (m): ", height)}
                  {tableData("Weight (kg): ", weight)}
                  {tableData("Blood Type: ", blood)}
                  {tableData("TIN No.: ", tin)}
                  {tableData("GSIS No.: ", gsis)}
                  {tableData("SSS No.: ", sss)}
                  {tableData("Pagibig No.: ", pagIbig)}
                  {tableData("PhilHealth No.: ", philhealth)}
                  {tableData("Residential Address: ", residentialAdd)}
                  {tableData("Permanent Address: ", permanentAdd)}
                </table>
              </div>
            </CardView>
          </div>

          <div className="col-lg-6" style={{ padding: "0  5px 0 5px" }}>
            <div className="mb-3 " style={{ height: "auto" }}>
              <CardView
                style={{
                  padding: 0,
                  borderRadius: 0,
                }}
              >
                <div
                  style={{
                    color: "#333",
                    borderBottom: "1px solid #ccc",
                    display: "flex",
                    paddingLeft: "1.5rem",
                    paddingTop: "1rem",
                    paddingBottom: "1rem",
                    alignItems: "center",
                  }}
                >
                  <p style={{ margin: 0 }}>Educational Background</p>
                </div>
                <div
                  className=""
                  style={{
                    paddingLeft: "1.5rem",
                    paddingTop: "1rem",
                    fontSize: "13px",
                  }}
                >
                  {educationalBackground.map((education, index) => {
                    return (
                      <table key={index}>
                        {tableData("Level: ", education?.educationLevel || "-")}
                        {tableData(
                          "Name of School: ",
                          education?.educationSchool || "-"
                        )}
                        {tableData(
                          "Basic Education/Degree/Course: ",
                          education?.educationDegree || "-"
                        )}
                        {tableData(
                          "Highest Level: ",
                          education?.educationHighest || "-"
                        )}
                        {tableData(
                          "Scholarship: ",
                          education?.educationHonors || "-"
                        )}
                        {tableData(
                          "From: ",
                          formatDate(education?.educationFrom) || "-"
                        )}
                        {tableData(
                          "To: ",
                          formatDate(education?.educationTo) || "-"
                        )}
                        {tableData(
                          "Year Graduated: ",
                          education?.educationYear || "-"
                        )}
                        <hr />
                      </table>
                    );
                  })}
                  {/*  */}
                </div>
              </CardView>
            </div>
            <div className="mb-3" style={{ height: "auto" }}>
              <CardView
                style={{
                  padding: 0,
                  borderRadius: 0,
                }}
              >
                <div
                  style={{
                    color: "#333",
                    borderBottom: "1px solid #ccc",
                    display: "flex",
                    paddingLeft: "1.5rem",
                    paddingTop: "1rem",
                    paddingBottom: "1rem",
                    alignItems: "center",
                  }}
                >
                  <p style={{ margin: 0 }}>Work Experience</p>
                </div>
                <div
                  className=""
                  style={{
                    paddingLeft: "1.5rem",
                    paddingTop: "1rem",
                    fontSize: "13px",
                  }}
                >
                  <div
                    className=""
                    style={{
                      paddingLeft: "1.5rem",
                      paddingTop: "1rem",
                      fontSize: "13px",
                    }}
                  >
                    {workExperienceBackground.map((workExp, index) => (
                      <table  key={index}>
                        {tableData("Position: ", workExp?.position || "-")}
                        {tableData("Company: ", workExp?.department || "-")}
                        {tableData("Monthly Salary: ", workExp?.salary || "-")}
                        {tableData(
                          "Salary/Job/Pay Grade: ",
                          workExp?.grade || "-"
                        )}
                        {tableData(
                          "Status of Appointment: ",
                          workExp?.appointment || "-"
                        )}
                        {tableData("From: ", formatDate(workExp?.from) || "-")}
                        {tableData("To: ", formatDate(workExp?.to) || "-")}
                        <hr />
                      </table>
                    ))}
                  </div>
                </div>
              </CardView>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default PersonalInfoPage;
